(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["unique-chain-add-on"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('unique-chain-add-on')) {
    customElements.define(
      'unique-chain-add-on',
      class UniqueChainAddOn extends HTMLElement {
        connectedCallback() {
          this.form = this.closest('product-form');
          this.addEventListener('change', this.syncSelection.bind(this));
          this.syncSelection();

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              if (event.data.sectionId !== this.dataset.sectionId) return;

              const source = event.data.html.querySelector(
                `unique-chain-add-on[data-section-id="${this.dataset.sectionId}"]`
              );
              this.updatePricesFrom(source);
            });
          }
        }

        disconnectedCallback() {
          if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
        }

        get withChainSelected() {
          return this.querySelector('input[value="with-chain"]')?.checked === true;
        }

        get chainVariantId() {
          return this.dataset.chainVariantId || '';
        }

        get addError() {
          return this.dataset.addError || '';
        }

        syncSelection() {
          if (!this.form) return;

          this.form.dataset.uniqueChainSelected = this.withChainSelected.toString();
          const paymentButton = this.form.querySelector('.shopify-payment-button');
          if (!paymentButton) return;

          paymentButton.hidden = this.withChainSelected;
          if (this.withChainSelected) {
            paymentButton.setAttribute('aria-hidden', 'true');
          } else {
            paymentButton.removeAttribute('aria-hidden');
          }
        }

        updatePricesFrom(source) {
          if (!source) return;

          const priceSelectors = [
            '[data-unique-chain-pendant-price]',
            '[data-unique-chain-bundle-price]',
          ];
          priceSelectors.forEach((selector) => {
            const targetPrice = this.querySelector(selector);
            const sourcePrice = source.querySelector(selector);
            if (targetPrice && sourcePrice) targetPrice.textContent = sourcePrice.textContent;
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
